const ChatIcon = () => {
	return (
		<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="28" cy="28" r="28" fill="#F7F7F7" />
			<g clip-path="url(#clip0_16383_36854)">
				<path
					d="M16.2105 41.2645V22.1066C16.2105 20.9341 16.6763 19.8096 17.5054 18.9804C18.3345 18.1513 19.459 17.6855 20.6316 17.6855H35.3684C36.5409 17.6855 37.6655 18.1513 38.4946 18.9804C39.3237 19.8096 39.7895 20.9341 39.7895 22.1066V30.9487C39.7895 32.1212 39.3237 33.2458 38.4946 34.0749C37.6655 34.904 36.5409 35.3698 35.3684 35.3698H22.1052L16.2105 41.2645Z"
					stroke="var(--general-count-action-color)"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M22.1053 23.5801H33.8948"
					stroke="var(--general-count-action-color)"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M22.1053 29.4746H30.9474"
					stroke="var(--general-count-action-color)"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_16383_36854">
					<rect width="35.3684" height="35.3684" fill="white" transform="translate(10.3158 10.3164)" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default ChatIcon;
